import React from 'react';
import './HelpModal.css';

const HelpModal = ({ onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="help-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Central de Ajuda</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          <p className="help-intro">
            Bem-vindo ao <strong>Walco Finance</strong>! Aqui está um resumo rápido das principais funcionalidades para ajudar a gerenciar suas finanças.
          </p>

          <div className="help-section">
            <h3><span>🔔</span> Alertas e Próximos Vencimentos</h3>
            <p>
              O sistema monitora automaticamente suas contas a pagar e receber. Gastos não quitados aparecem no topo em uma barra de destaque. 
              Para garantir que você não esqueça, a barra <strong>vibra</strong> por 3 segundos sempre que você entra no sistema e repete o aviso a cada <strong>3 minutos</strong> se houver pendências graves. 
              <em> Dica:</em> Clique na barra para fazer um <strong>scroll automático</strong> direto para a lista de transações.
            </p>
          </div>

          <div className="help-section">
            <h3><span>🎯</span> Metas e 💰 Orçamentos</h3>
            <p>
              • <strong>Metas:</strong> Crie objetivos de economia (ex: Reserva de Emergência). Acompanhe o progresso real do seu saldo em relação ao alvo.<br/>
              • <strong>Orçamentos:</strong> Defina um teto de gastos por categoria (ex: Lazer). O sistema avisa visualmente com barras de progresso se você estiver próximo de estourar o limite definido para o mês.
            </p>
          </div>

          <div className="help-section">
            <h3><span>⚙️</span> Ferramentas e Cadastros</h3>
            <p>
              • <strong>Categorias:</strong> Personalize suas tags com cores exclusivas para organizar seus relatórios.<br/>
              • <strong>Cartões de Crédito:</strong> Gerencie faturas e saiba exatamente de qual cartão saíram seus gastos.<br/>
              • <strong>Conta Business/Familiar:</strong> No menu superior, alterne entre sua visão <strong>Pessoal</strong> e <strong>Business</strong> para gerenciar finanças compartilhadas com outros membros em tempo real.
            </p>
          </div>

          <div className="help-section">
            <h3><span>🚀</span> Gestão de Transações</h3>
            <p>
              O botão <strong>+ Nova Transação</strong> abre o formulário otimizado. Você pode:<br/>
              • Anexar comprovantes e documentos.<br/>
              • Definir recorrência mensal automática.<br/>
              • Marcar como "Pago" ou "Pendente" para controle de fluxo de caixa.<br/>
              • Importar extratos bancários inteiros (Nubank, Itaú, etc) via arquivo <strong>CSV</strong> para ganhar tempo.
            </p>
          </div>

          <div className="help-section">
            <h3><span>🌗</span> Personalização e Relatórios</h3>
            <p>
              • <strong>Temas:</strong> No seu Perfil (WA), escolha a cor principal do sistema. Use o botão ☀️/🌙 para alternar para o <strong>Modo Escuro</strong>.<br/>
              • <strong>Exportação:</strong> Gere relatórios profissionais em <strong>PDF</strong> para conferência ou baixe tudo em <strong>Planilha CSV</strong> para manipulação externa.
            </p>
          </div>

        </div>
        <div className="modal-footer">
          <button className="modal-btn modal-btn-primary" onClick={onClose}>Entendi</button>
        </div>
      </div>
    </div>
  );
};

export default HelpModal;
